import { useState } from 'react';

export const useEventsScreen = () => {
  const [selectedKey, setSelectedKey] = useState('medVox');

  const updateData = (key: string) => {
    switch (key) {
      case 'roboCall':
        setSelectedKey('roboCall');
        break;
      case 'medVox':
        setSelectedKey('medVox');
        break;
    }
  };

  return {
    selectedKey,
    updateData,
  };
};
